import { render } from "./property-search.vue?vue&type=template&id=530c741c"
import script from "./property-search.vue?vue&type=script&lang=js"
export * from "./property-search.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__